import { useDocumentVisibility } from "@vueuse/core";
import { computed } from "vue";

const visibility = useDocumentVisibility();

// Vue <transition>/<transition-group> advance enter/leave through requestAnimationFrame,
// which browsers pause in hidden tabs. Until the tab is shown again, entering elements
// stay invisible (*-enter-from) and leaving ones stay in the DOM, then the whole backlog
// replays at once. Bind `:css="isPageVisible"` so updates in a hidden tab apply instantly.
const isPageVisible = computed(() => visibility.value === "visible");

export { isPageVisible };
